import Mandates from "@/app/mandates/page";

export const Constants = {
    login: {
        login: 'LOG IN',
        details: 'Please enter your details here',
        phoneNumber: 'Phone Number',
        mobileNumber: 'Mobile Number',
        overWhatsApp: 'Send me updates over WhatsApp',
        loginConsent:'I hereby give consent to change the existing EMI due date scheduled at 8th of every month to be revised to 3rd of every month and set up e-mandate accordingly.',
        registeredNum: 'Change Registered Number',
        proceeding: 'By proceeding, you accept the ',
        termsAndCondtions: 'Terms and Conditions. ',
        read: 'Read the ',
        privacyPolicy: 'Privacy Policy here',
        here: 'here.',
        getOtp: 'Get OTP',
        error:'Invalid mobile number. Please enter the number registered with Hero Fincorp Or contact our customer service team to update your contact information.'
    },
    otp: {
        enterOtp: 'Please enter the OTP code sent to',
        didnotget: 'Didn’t receive the OTP? ',
        resendCode: 'Resend Code',
        verify: 'Verify',
        enterOtpText:'Please enter the OTP code sent to your registered mobile number',
    },
    verifyDetails: {
        verify: 'Verify Yourself',
        enterDetails: 'Please check your below details',
        firstName: 'First Name',
        lastName: 'Last Name',
        phoneNumber: 'Phone Number',
        lanId: 'Application ID',
        dob: 'Date of Birth',
        loanAmount:'Loan Amount',
        loanTenure:'Loan Tenure',
        pos:'Principal Outstanding',
        product:'Product',
        proceed: 'Verify And Proceed'

    },
    mandates: {
        enterDetails: 'Enter below details',
        selectMandate: 'Please select your mandate',
        upi: 'UPI',
        debitCard: 'Debit Card',
        upiId: 'UPI ID',
        netBank: 'Net Banking',
        bankName: 'Bank Name',
        accontNum: 'Account Number',
        ifscCode: 'IFSC Code',
        proceed: 'Proceed',
        upiIdError: `Entered UPI Id doesn't match the associated name.`,
        validUpi: 'Please enter your valid UPI ID.',
        ifscCodeError: `Entered IFSC code is not correct.`,
        validIfscCode: 'Please enter your valid IFSC Code.',
        accountNumberError: `Entered account number is not valid.`,
        validAccountNumber: 'Please enter your valid account number.',
        nameMissMatchError:`Name as per bank doesn't match, Please try with different UPI Id.`,
        mandateNote :'Note: For a faster repayment setup process please select either Debit Card or UPI.',
        mandateWait:'Please check your sms or notification in payment app to approve mandate request.',
        timeoutMessage:'We have not received any response for your upi mandate Request. Please retry after sometime.'
    },
    softpull: {
        cibilReportLinkHeading: 'Please click on the below link to view your CIBIL report.',
        cibilReportLinkErrorHeading: 'Unable to generate CIBIL report link',
        cibilContactUs:'If you are unable to view your report, please contact us at customer.care@herofincorp.com for assistance.'
    }
};